import React from 'react';
import { WidgetProps } from '@rjsf/core';
import { Message, Icon } from 'semantic-ui-react';
import PercentWidget from './PercentWidget';

const RetainageWidgetWithInfo: React.FC<WidgetProps> = (props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
      <div style={{ flex: '0 0 auto' }}>
        <PercentWidget {...props} />
      </div>
      <div style={{ flex: '1', maxWidth: '50%' }}>
        <Message
          size='small'
          style={{
            margin: 0,
            backgroundColor: '#fffbe6',
            borderColor: '#faad14',
            color: '#b8860b',
            border: '1px solid #faad14',
          }}
        >
          <Icon name='warning circle' />
          Changing the default retainage % now, will ONLY affect line items added immediately after the % change.
          ALTERNATIVELY consider changing the retainage % at the individual line item.
        </Message>
      </div>
    </div>
  );
};

export default RetainageWidgetWithInfo;